import React, { FC } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
}

const SelectField: FC<Props> = ({ title }) => {
  return (
    <Box width="full" gap="s4">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {title}
      </Text.Normal>
      <Box
        background="grey000White"
        paddingY="s8"
        paddingX="s12"
        borderRadius={{ all: 'abs008' }}
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      >
        <Text.Normal color="grey600">{i18n.t('common.select_default')}</Text.Normal>
        <Icon.Small icon="caret-down" color="grey800" />
      </Box>
    </Box>
  )
}

export default SelectField
